// Receipt pages: the pure rules behind the page strip (what counts as a page, how a paste is named, the pill text).

const EXT = /\.(pdf|png|jpe?g|webp|gif)$/i;

export const isPageFile = (f) => !!f && (f.type === 'application/pdf' || f.type.startsWith('image/') || EXT.test(f.name || ''));

// The images and PDFs among dropped or chosen files, in the order given.
export const acceptedFiles = (list) => Array.from(list || []).filter(isPageFile);

// The image or PDF items of a paste as files named "<prefix> page N.<ext>", numbered after the pages already there.
export function pastedFiles(clipboardData, prefix, have) {
  const items = Array.from(clipboardData?.items || []).filter((i) => i.kind === 'file' && (i.type.startsWith('image/') || i.type === 'application/pdf'));
  return items.map((it, k) => {
    const b = it.getAsFile();
    const ext = b.type === 'application/pdf' ? 'pdf' : (b.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
    return new File([b], `${prefix} page ${have + k + 1}.${ext}`, { type: b.type });
  });
}

export const pagesText = (n) => (!n ? 'Missing' : n === 1 ? 'Attached' : `${n} pages`);

export const isImageFile = (f) => !!f && f.type.startsWith('image/');
